<template>
  <div class="login">
    <UserHeader :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"></UserHeader>

    <div class="login_container" :class="[language == 'zh'?'zhFamily':'enfamily']">
      <div class="login_container_box">
        <div class="login_container_box_img">
         <img src="../assets/image/User/login_icon.png" alt />
        </div>
        <div class="login_container_box_login">
          <Forget></Forget>
        </div>
      </div>
    </div>
    <!-- <UserFooter></UserFooter> -->
  </div>
</template>

<script>
export default {
  components: {
    UserHeader: () => import("@/components/User/UserHeader.vue"),
    Forget: () => import("@/components/User/Forget.vue")
    // UserFooter: () => import("@/components/User/UserFooter.vue")
  }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;

  .login_container {
    width: 100%;
    // height: calc(100vh);
    background: url("../assets/image/User/background_login.png");
    background-repeat: no-repeat;
    background-size: cover;

    background-position: center 0;
    .login_container_box {
      width: 1200px;
      margin: auto;
      display: flex;
      justify-content: space-between;

      .login_container_box_img {
        margin-top: 100px;
        width: 700px;
        // height: 415px;
        img {
          width: 100%;
          // height: 415px;
        }
      }
      .login_container_box_login {
        margin-top: 100px;
        border-radius: 4px;
        min-width: 464px;
        margin-bottom: 100px;
        // min-height: 600px;
        // background: #fff;
      }
    }
  }
}
</style>